import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const IMAGES = {
  hero: "/hero.jpg",
  texture: "https://static.prod-images.emergentagent.com/jobs/8d49504a-ee8a-41cb-9ae6-3edc1f519625/images/31752e1d5b3a05cfa23b9c1555f1f4f007da35c125dfa3adc6b5e7b88ce90ea5.png",
  hoodie: "https://static.prod-images.emergentagent.com/jobs/8d49504a-ee8a-41cb-9ae6-3edc1f519625/images/1105807f5b8512f6511b31a88b882039b231563ec45ad4601b141006425ce783.png",
  vinyl: "https://static.prod-images.emergentagent.com/jobs/8d49504a-ee8a-41cb-9ae6-3edc1f519625/images/8b2bf43605a87aff095a5456e745e7767c7544e91b99f77dacd2086722de9049.png",
  connect: "https://static.prod-images.emergentagent.com/jobs/8d49504a-ee8a-41cb-9ae6-3edc1f519625/images/4a846d90e99eef24f15ddb8556f005ec60913be9bbcf5314957e8b04596b4de9.png",
};

export function imgUrl(src) {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  if (src.startsWith("/")) return src; // root-relative static asset
  return `${API_BASE}/files/${src}`;
}
